import PropTypes from "prop-types"
import { SEARCHABLE_MENU_ITEM, TABLE_GROUP_DROPDOWN, LIST_ITEM_TEXT_OPTION } from "helpers/shapes"
import { Paper } from "@mui/material"
import Table from "components/securities-table/table"
import AssetsTableHeader from "components/assets-table-header"
import "./styles.scss"

function CompositeAssetAnalyticsTable({
  aggregatedRow,
  columns,
  columnOrder,
  columnOrderOptions,
  count,
  downloadData,
  dispatch,
  downloadButtonTooltip,
  foundSecurities,
  groupDropdown,
  idSort,
  isActive,
  menuItems,
  metricType,
  metricTypeOptions,
  openFactorProfile,
  openSecurityProfile,
  openCompositeSecurity,
  page,
  selectedSubView,
  selectedView,
  setColumnOrder,
  setMetricType,
  setPage,
  setSelectedGroup,
  setSelectedSubView,
  setSelectedView,
  setSort,
  status,
  subViewOptions,
}) {
  return (
    <Paper square className="modules_composite-asset-analytics-table">
      <AssetsTableHeader
        {...{
          columnOrder,
          columnOrderOptions,
          downloadData,
          downloadButtonTooltip,
          menuItems,
          metricType,
          metricTypeOptions,
          selectedSubView,
          selectedView,
          setColumnOrder,
          setMetricType: (metricType) => setMetricType(metricType, selectedView),
          setSelectedSubView,
          setSelectedView,
          subViewOptions,
        }}
      />
      <Table
        {...{
          aggregatedRow,
          allowIdSort: true,
          columns,
          columnOrder,
          count,
          disableColumnsSelection: true,
          disableRowSelection: true,
          dispatch,
          foundSecurities,
          groupDropdown,
          idSort,
          isActive,
          openFactorProfile,
          openSecurityProfile,
          openCompositeSecurity,
          outsidePagination: true,
          page,
          rowIdClickOverride: (item) => setSelectedGroup(item.id),
          selectedSecurities: {},
          setPage,
          setSort,
          status,
        }}
      />
    </Paper>
  )
}

CompositeAssetAnalyticsTable.propTypes = {
  modelId: PropTypes.string,
  assetName: PropTypes.string,
  assetType: PropTypes.string,
  aggregatedRow: PropTypes.object.isRequired,
  currentGrouping: PropTypes.object,
  columns: PropTypes.array.isRequired,
  columnOrder: PropTypes.string.isRequired,
  columnOrderOptions: PropTypes.arrayOf(LIST_ITEM_TEXT_OPTION),
  disableColumnClick: PropTypes.bool,
  count: PropTypes.number.isRequired,
  downloadData: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  downloadButtonTooltip: PropTypes.string.isRequired,
  foundSecurities: PropTypes.array.isRequired,
  groupDropdown: TABLE_GROUP_DROPDOWN,
  idSort: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  menuItems: PropTypes.arrayOf(SEARCHABLE_MENU_ITEM),
  metricType: PropTypes.string,
  metricTypeOptions: PropTypes.arrayOf(LIST_ITEM_TEXT_OPTION),
  openFactorProfile: PropTypes.func.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openCompositeSecurity: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  selectedSubView: PropTypes.string,
  selectedView: PropTypes.string.isRequired,
  viewType: PropTypes.string,
  setColumnOrder: PropTypes.func.isRequired,
  setMetricType: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  setSelectedGroup: PropTypes.func.isRequired,
  setSelectedSubView: PropTypes.func.isRequired,
  setSelectedView: PropTypes.func.isRequired,
  setSort: PropTypes.func.isRequired,
  status: PropTypes.string,
  subViewOptions: PropTypes.arrayOf(LIST_ITEM_TEXT_OPTION),
  hideColumnWith: PropTypes.func,
}

export default CompositeAssetAnalyticsTable
